import { useMutation, useQueryClient } from "@tanstack/react-query"
import { useTranslation } from "react-i18next"
import { toast } from "sonner"

import type { FormColumn } from "../schemas/column-schema"

import { api } from "@/lib/api-client"
import { queryKeys } from "@/lib/query-keys"

import { useAIParserSession } from "./use-ai-parser-session"

type Data = {
  sessionId: string
  columnId: string
} & FormColumn

function editColumn(data: Data) {
  return api.put("/parser/update-column", {
    session_id: data.sessionId,
    column_id: data.columnId,
    name: data.name,
    data_type: data.dataType,
    description: data.description,
    option_type_id: data.optionTypeId,
    options: data.options,
  })
}

export function useEditColumnMutation() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { currentSessionId } = useAIParserSession()

  return useMutation({
    mutationFn: editColumn,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: queryKeys.fullSession(currentSessionId ?? ""),
      })
      toast.success(t("pages.ai_parser.toasts.column_updated"))
    },
  })
}
